import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Button, Col, NavDropdown, Row } from 'react-bootstrap';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { MdMail } from "react-icons/md";
import { FaMapMarkerAlt } from "react-icons/fa"
import { HelmetProvider } from "react-helmet-async";

import './scss/style.scss';
import 'bootstrap/dist/css/bootstrap.css';
import "animate.css/animate.min.css";

import Home from './pages/Home';
import PageNotFound from './pages/PageNotFound';
import BlogList from './pages/Blog/BlogList';
import BlogDetail from './pages/Blog/BlogDetail';
import EventsPage from './pages/Events/EventsPage';
import EventDetail from './pages/Events/EventDetail';
import EventConfirmation from './pages/Events/EventConfirmation';

import burgermenu from './assets/burger_menu.png'
import ScrollButton from './components/ScrollButton'
import logo from "./assets/logo.png"
import Advisory from './pages/Services/Advisory';
import ScrollToTopOnMount from './helpers/ScrollToTopOnMount';
import Mssp from './pages/Services/Mssp';
import Training from './pages/Services/Training';
import BecomePartner from './pages/BecomePartner';
import Solution from './pages/Solutions/Solution';
import AnalyticsTracker from './helpers/AnalyticTracker';

const solution_url = [
  {
    url: '/solutions/cloud-native-application-protection-platform',
    title: 'Cloud Native Application Protection Platform (CNAPP)'
  },
  {
    url: "/solutions/cloud-security-posture-management",
    title: "Cloud Security Posture Management (CSPM)"
  },
  {
    url: "/solutions/cloud-workload-protection-platform",
    title: "Cloud Workload Protection Platform (CWPP)"
  },
  {
    url: "/solutions/cloud-infrastructure-entitlement-management",
    title: "Cloud Infrastructure Entitlement Management (CIEM)"
  },
  {
    url: "/solutions/data-security-posture-management",
    title: "Data Security Posture Management (DSPM)"
  },
  {
    url: "/solutions/container-and-kubernetes-security",
    title: "Container and Kubernetes Security"
  },
  {
    url: "/solutions/multi-cloud-compliance",
    title: "Multi-Cloud Compliance"
  },
  {
    url: "/solutions/vulnerability-management",
    title: "Cloud Vulnerability Management"
  },
  {
    url: "/solutions/api-security",
    title: "API Security"
  },
  {
    url: "/solutions/cloud-detection-and-response",
    title: "Cloud Detection and Response"
  },
  {
    url: "/solutions/shift-left-security",
    title: "Shift Left Security"
  },
  {
    url: "/solutions/ai-security-posture-management",
    title: "AI Security Posture Management (AI-SPM)"
  },
  {
    url: "/solutions/ai-driven-cloud-security",
    title: "AI-Driven Cloud Security"
  },
  {
    url: "/solutions/agentless-sidescanning",
    title: "Agentless Cloud Security"
  },
  {
  }
]

const Header = () => {
  const location = useLocation()

  return(
    <div className='sticky-top'>
      <Navbar collapseOnSelect expand="lg">
        <Container>
          <Navbar.Brand href="/">
            <img src={logo} className="logo-main" allt=""/>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav">
            <img src={burgermenu} alt="" className='burger-menu'/>
          </Navbar.Toggle>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto align-items-center gap-4">
              <Nav.Link href="/" className={[location.pathname==='/'?'active':'']}>Home</Nav.Link>
              <NavDropdown title="Solutions" className={[location.pathname.indexOf('/solutions') > -1 ? 'active':'']}>
                {
                  solution_url.map((item, index) => (
                    <NavDropdown.Item key={"solution-url"+index} href={item.url} className={[location.pathname.indexOf(item.url) > -1?'active':'']}>{item.title}</NavDropdown.Item>
                  ))
                }
              </NavDropdown>
              <NavDropdown title="Services" className={[location.pathname.indexOf('advisory-consultancy') > -1 || location.pathname.indexOf('managed-security-service-provider') > -1 || location.pathname.indexOf('training-certification') > -1 ? 'active':'']}>
                <NavDropdown.Item href="/advisory-consultancy" className={[location.pathname.indexOf('advisory-consultancy') > -1?'active':'']}>Advisory & Consultancy</NavDropdown.Item>
                <NavDropdown.Item href="/managed-security-service-provider" className={[location.pathname.indexOf('managed-security-service-provider') > -1?'active':'']}>Managed Security Service Provider (MSSP)</NavDropdown.Item>
                <NavDropdown.Item href="/training-certification" className={[location.pathname.indexOf('training-certification') > -1?'active':'']}>Training & Certification</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="/become-partner" className={[location.pathname.indexOf('become-partner') > -1?'active':'']}>Become Partner</Nav.Link>
              <Nav.Link href="/news" className={[location.pathname.indexOf('/news') > -1?'active':'']}>News</Nav.Link>
              <Nav.Link href="/events" className={[location.pathname.indexOf('/events') > -1?'active':'']}>Events</Nav.Link>
              <Nav.Link href="/#demo-form">
                <Button variant='brand'>Book Demo</Button>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  )
}

const Footer = () => {
  return(
    <div className='footer'>
      <ScrollToTopOnMount/>
      <Container className='pt-5 pb-5'>
        <Row className='footer-info'>
          <Col md={4} xs={6} className="mt-4">
            <img src={logo} alt="" style={{width:120, marginTop:-30}}/>
          </Col>
          <Col md={4} xs={6} className="mt-2">
            <div className='d-flex flex-row gap-3'>
              <div>
                <MdMail size={25}/>
              </div>
              <div className='flex-fill'>
                <strong>Email</strong>
                <p>info@siberwander.com</p>
              </div>
            </div>
          </Col>
          <Col md={4} xs={12} className="mt-2">
            <div className='d-flex flex-row gap-3'>
              <div>
                <FaMapMarkerAlt size={25}/>
              </div>
              <div className='flex-fill'>
                <strong>Address</strong>
                <p>Centennial Tower, 38’th floor, Unit H Jl. Gatot Subroto, kavling 24-25, Jakarta Selatan, 12930, Indonesia</p>
              </div>
            </div>
          </Col>
        </Row>
        <div className='hr mt-4 mb-4'/>
        <div className='text-center'>© {new Date().getFullYear()} Siberwander, All rights reserved</div>
      </Container>
    </div>
  )
}

const PageLayout = (page) => {
  return(
    <>
      <Header/>
      {page}
      <Footer/>
    </>
  )
}

function App() {
  
  return (
     <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route exact path='/' element={PageLayout(<Home/>)}/>
          <Route exact path='/advisory-consultancy' element={PageLayout(<Advisory/>)}/>
          <Route exact path='/managed-security-service-provider' element={PageLayout(<Mssp/>)}/>
          <Route exact path='/training-certification' element={PageLayout(<Training/>)}/>
          <Route exact path='/become-partner' element={PageLayout(<BecomePartner/>)}/>
          <Route exact path='/news' element={PageLayout(<BlogList/>)}/>
          <Route exact path='/news/:slug' element={PageLayout(<BlogDetail/>)}/>
          <Route exact path='/events' element={PageLayout(<EventsPage/>)}/>
          <Route exact path='/events/:slug' element={PageLayout(<EventDetail/>)}/>
          <Route exact path='/events/confirm/:token' element={<EventConfirmation/>}/>
          {
            solution_url.map((item, index) => (
              <Route key={"route-solution"+index} exact path={item.url} element={PageLayout(<Solution/>)}/>
            ))
          }
          <Route path='*' element={<PageNotFound/>}/>
        </Routes>
        <AnalyticsTracker />
        <ScrollButton/>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
